module.exports = __webpack_public_path__ + "img/down-angle.3f84a878.svg";